import { render, staticRenderFns } from "./GameHistoryTab.vue?vue&type=template&id=094863c5&"
import script from "./GameHistoryTab.vue?vue&type=script&lang=js&"
export * from "./GameHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports